import React from 'react';
import paystackLogo from '../../assets/images/payment/paystack.svg';
import stripeLogo from '../../assets/images/payment/stripe.svg';
import applePayLogo from '../../assets/images/payment/apple-pay.png';

const SIZE_CLASSES = {
  sm: { paystack: 'h-4', stripe: 'h-3.5', text: 'text-[11px]', gap: 'gap-1' },
  md: { paystack: 'h-5', stripe: 'h-4', text: 'text-xs', gap: 'gap-1.5' },
  lg: { paystack: 'h-6', stripe: 'h-5', text: 'text-sm', gap: 'gap-2' },
  header: { paystack: 'h-5', stripe: 'h-4', text: 'text-xs', gap: 'gap-1.5' },
};

export function PaystackStripeBrand({ size = 'md', className = '' }) {
  const s = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  return (
    <span
      className={`inline-flex items-center flex-wrap ${s.gap} ${s.text} text-slate-600 ${className}`}
      aria-label="Paystack, a Stripe company"
    >
      <img src={paystackLogo} alt="" className={`${s.paystack} w-auto object-contain`} aria-hidden />
      <span className="text-slate-400">a</span>
      <img src={stripeLogo} alt="" className={`${s.stripe} w-auto object-contain`} aria-hidden />
      <span>company</span>
    </span>
  );
}

export function ApplePayMark({ className = '' }) {
  return (
    <img
      src={applePayLogo}
      alt="Apple Pay"
      className={`h-5 w-auto object-contain ${className}`}
    />
  );
}
